import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_PARAM } from "./actionTypes";
import { getParametersSuccess, getParametersError } from "./actions";

// Include call API
import { getParametersAPI } from "../../../api/securityparameters";

const parameterAPI = getParametersAPI();

function* getAllParameters({ payload: { user } }) {
  console.log("param saga")
  try {
    const response = yield call( parameterAPI.getAllParameters, user.token);
    yield put(getParametersSuccess(response.params, response.message));
  } catch (error) {
    yield put(getParametersError(error));
  }
}

export function* watchGetParameters() {
  yield takeEvery(GET_PARAM, getAllParameters);
}

function* getParametersSaga() {
  yield all([fork(watchGetParameters)]);
}

export default getParametersSaga;
